import { useState, useEffect, useCallback } from 'react';
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Select, { components } from 'react-select';
import AX from 'axios';
import axios from '../_actions/axiosInstance';
import useDebounce from '../helpers/debounceHelper';
import { ReactComponent as SearchIcon } from '../assets/images/search.svg';

const NoOptionsMessage = props => {
  // eslint-disable-next-line
  if (props?.selectProps?.inputValue) {
    return (
      <div className="facility-search-no-options">
        <div>No options</div>
      </div>
    );
  }
  return (
    <div className="facility-search-no-options">
      <div>Start typing to find Facility or</div>
      <Link to="/facility_list">Check Facility List</Link>
    </div>
  );
};

const AutocompleteField = ({
  placeholder,
  getValue,
  getCustomOptionLabel,
  path,
  isMulti,
  isHeader,
  initStyles,
  extraEomponents,
  isClearable,
  extrclass
}) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState();
  const [value, setSelectValue] = useState();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const debouncedSearchValue = useDebounce(inputValue, 300);
  const [source, setSource] = useState();

  const DropdownIndicator = props => {
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <components.DropdownIndicator {...props}>
        <SearchIcon />
      </components.DropdownIndicator>
    );
  };

  const setValue = val => {
    setSelectValue(val);
    if (isMulti) {
      getValue((val && val.map(x => x.id)) || []);
    } else {
      getValue(val?.id || null, val);
    }
    if (isHeader) {
      setSelectValue(null);
    }
  };

  const resolveParams = text => {
    return text
      ? `?q%5Bterm%5D=${text || ''}&q%5B_type%5D=query&no_format=true`
      : '?q%5B_type%5D=query';
  };

  const getRecords = useCallback(async () => {
    const src = AX.CancelToken.source();
    setSource(src);
    setLoading(true);
    try {
      const res = await axios.get(`${path}${resolveParams(debouncedSearchValue)}`, {
        cancelToken: src.token
      });
      if (res.data.results) {
        setOptions(res.data.results);
      } else {
        setOptions(res.data.data);
      }
    } catch {
      setOptions([]);
    } finally {
      setLoading(false);
    }
  }, [debouncedSearchValue, path]);

  const getOptionValue = option => option.id;
  const getOptionLabel = option =>
    getCustomOptionLabel ? getCustomOptionLabel(option) : option.text || option.name;

  const changeInputValue = val => {
    if (source) {
      source.cancel();
    }
    setInputValue(val);
  };

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (debouncedSearchValue) {
      getRecords();
    }
  }, [debouncedSearchValue, getRecords]);

  const styles = {
    container: provided => ({
      ...provided,
      width: '-webkit-fill-available'
    }),
    menu: provided => ({
      ...provided,
      zIndex: 99,
      width: isHeader ? 'calc(100% - 1.4em)' : 'calc(100% - 2.5rem)'
    })
  };
  const shouldOpenMenu = Boolean(inputValue && String(inputValue).trim().length > 0);
  return (
    <Select
      className={`px-3 ${extrclass}`}
      isLoading={loading}
      menuIsOpen={shouldOpenMenu}
      styles={initStyles || styles}
      isMulti={isMulti}
      cacheOptions
      options={options}
      components={{ DropdownIndicator, NoOptionsMessage, ...extraEomponents }}
      placeholder={placeholder}
      loadingMessage={() => 'Loading..'}
      getOptionValue={getOptionValue}
      getOptionLabel={getOptionLabel}
      inputValue={inputValue}
      value={value}
      isClearable={isClearable}
      onInputChange={changeInputValue}
      onChange={setValue}
    />
  );
};

AutocompleteField.propTypes = {
  placeholder: PropTypes.string.isRequired,
  getValue: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  isMulti: PropTypes.bool,
  initStyles: PropTypes.instanceOf(Object),
  extraEomponents: PropTypes.instanceOf(Object),
  isClearable: PropTypes.bool,
  isHeader: PropTypes.bool,
  getCustomOptionLabel: PropTypes.func,
  extrclass: PropTypes.string
};

AutocompleteField.defaultProps = {
  isMulti: false,
  initStyles: null,
  extraEomponents: {},
  isClearable: false,
  isHeader: false,
  getCustomOptionLabel: null,
  extrclass: ''
};

export default AutocompleteField;

export const FilterAutocompleteField = ({ title, placeholder, getValue, path, isMulti }) => {
  return (
    <div className="d-flex justify-content-center my-1 p-3 flex-column" style={{ flex: '50%' }}>
      <div
        className="d-flex w-100 justify-content-center p-2 mb-3"
        style={{
          borderBottomColor: 'rgba(0, 0, 0, 0.07)',
          borderBottomStyle: 'solid',
          borderBottomWidth: '1px'
        }}
      >
        <label htmlFor={`id-${path.split('/')[-1]}`}>{title}</label>
      </div>
      <AutocompleteField
        isMulti={isMulti}
        placeholder={placeholder}
        getValue={getValue}
        path={path}
      />
    </div>
  );
};

FilterAutocompleteField.propTypes = {
  // type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  getValue: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  isMulti: PropTypes.bool
};

FilterAutocompleteField.defaultProps = {
  isMulti: false
};
